import axios from 'axios';
import store from '@/store';

const authenticator = axios.create({
  baseURL: process.env.VUE_APP_DOMAIN
});

authenticator.check = function(token) {
  const result = new Promise((resolve, reject) => {
    if (localStorage.getItem('authenticated')) {
      const access_token = JSON.parse(localStorage.getItem('authenticated'))
        .access_token;

      authenticator.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${access_token}`;

      authenticator
        .get('/users/me')
        .then(response => {
          resolve();
        })
        .catch(error => {
          this.reset();
          reject();
        });
    } else if (token) {
      authenticator.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${token}`;

      authenticator
        .get('/users/me')
        .then(response => {
          this.set(token);
          store.dispatch('entities/users/get', {}, { root: true });
          resolve();
        })
        .catch(error => {
          this.reset();
          reject();
        });
    } else {
      reject();
    }
  });

  return result;
};

authenticator.set = function(token) {
  return new Promise(resolve => {
    const authenticated = { access_token: token };
    localStorage.setItem('authenticated', JSON.stringify(authenticated));
    resolve();
  });
};

authenticator.reset = function() {
  localStorage.removeItem('authenticated');
};

export default authenticator;
